import { z } from "zod";
import { ColumnSchema, ViewSchema, ViewType } from "./views";

export enum OrganizationBillingClientsColumn {
    CLIENT = "client",
    PLAN = "plan",
    STATUS = "status",
    EXTRA_ENTITIES = "extraEntities",
    WHY = "why",
}

const ClientColumnSchema = ColumnSchema.extend({
    id: z.literal(OrganizationBillingClientsColumn.CLIENT),
});

const PlanColumnSchema = ColumnSchema.extend({
    id: z.literal(OrganizationBillingClientsColumn.PLAN),
});

const StatusColumnSchema = ColumnSchema.extend({
    id: z.literal(OrganizationBillingClientsColumn.STATUS),
});

const ExtraEntitiesColumnSchema = ColumnSchema.extend({
    id: z.literal(OrganizationBillingClientsColumn.EXTRA_ENTITIES),
});

const WhyColumnSchema = ColumnSchema.extend({
    id: z.literal(OrganizationBillingClientsColumn.WHY),
});

export const OrganizationBillingClientsViewSchema = ViewSchema.extend({
    type: z.literal(ViewType.ORGANIZATION_BILLING_CLIENTS),
    columns: z.array(
        z.discriminatedUnion("id", [
            ClientColumnSchema,
            PlanColumnSchema,
            StatusColumnSchema,
            ExtraEntitiesColumnSchema,
            WhyColumnSchema,
        ]),
    ),
});

export type OrganizationBillingClientsView = z.infer<
    typeof OrganizationBillingClientsViewSchema
>;
